import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
import CampaignModel from '@/model/CampaignModel.js';

/**
 * @method apiGetCampaign
 * @method apiGetCampaignDetail
 * @method apiRedeemCampaign
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },
    /**
     * @param {String} strBzbsToken
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /service/config/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /service/config/CampaignConfigModel.js
     */
    apiGetCampaign: function (strBzbsToken, objListConfig, objListFilterConfig) {
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }

        var strUrl = Vue.bzbsConfig.bzbsServiceUrl+ "/campaign";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then((response) => {
                var arrCampaign = [];
                for (var i of response.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                resolve(arrCampaign);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    /**
     * @param {String} strBzbsToken
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /service/config/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /service/config/CampaignConfigModel.js
    */
    apiGetCampaignGift: function (strBzbsToken, objListConfig, objListFilterConfig) {
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }

        var strUrl = Vue.bzbsConfig.bzbsModuleUrl+ "/campaign";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then((response) => {
                var arrCampaign = [];
                for (var i of response.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                resolve(arrCampaign);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    /**
     * @param {String} strBzbsToken (Require)
     * @param {Object} objDetailConfig (Require) CampaignConfigModel - /service/config/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (strBzbsToken, objDetailConfig) {
        var params = objDetailConfig.getParams();
        // var url = Vue.bzbsConfig.bzbsServiceUrl + "/campaign/" + objDetailConfig.strId;
        var url = Vue.bzbsConfig.bzbsModuleUrl + "/campaign/" + objDetailConfig.strId;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, strBzbsToken, params).then((data) => {
                var campaign = new CampaignModel(data.data);
                resolve(campaign);
            }).catch((error) => {
                reject(error);
            });
        });

    },

    /**
     * @param {String} strBzbsToken
     * @param {String|Number} campaignId
     * @param {Object} objRedeemConfig RedeemConfigModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemProfileInfoConfig RedeemShippingAdressModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemInfoConfig RedeemInfoConfigModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemLocationConfig RedeemLocationConfigModel - /service/config/CampaignModel.js
     * @param {Object} objRedeemOtherConfig RedeemOtherConfigModel - /service/config/CampaignModel.js
     */
    apiRedeemCampaign: function (strBzbsToken, campaignId, objRedeemConfig, objRedeemProfileInfoConfig, objRedeemInfoConfig, objRedeemLocationConfig, objRedeemOtherConfig) {
        var params = {};

        if (!campaignId) {
            // failCallback("-9400", "-9400", "Bad parameter::Missing campaign model configuration.", "template_send", objRedeemConfig);
            return null;
        }

        if (!objRedeemConfig) {
            // failCallback("-9400", "-9400", "Bad parameter::Missing redeem configuration.", "template_send", objRedeemConfig);
            return null;
        } else {
            if (objRedeemConfig.redeemMedia) params.redeem_media = objRedeemConfig.redeemMedia;
            if (objRedeemConfig.walletCard) params.walletcard = objRedeemConfig.walletCard;
        }

        if (objRedeemProfileInfoConfig) {
            if (objRedeemProfileInfoConfig.firstName)
                params.firstname = objRedeemProfileInfoConfig.firstName;

            if (objRedeemProfileInfoConfig.lastName)
                params.lastname = objRedeemProfileInfoConfig.lastName;

            if (objRedeemProfileInfoConfig.address)
                params.address = objRedeemProfileInfoConfig.address;

            if (objRedeemProfileInfoConfig.contactNumber)
                params.contact_number = objRedeemProfileInfoConfig.contactNumber;

            if (objRedeemProfileInfoConfig.email)
                params.email = objRedeemProfileInfoConfig.email;

            if (objRedeemProfileInfoConfig.shippingFirstName)
                params.shippingFirstName = objRedeemProfileInfoConfig.shippingFirstName;

            if (objRedeemProfileInfoConfig.shippingLastName)
                params.shippingLastName = objRedeemProfileInfoConfig.shippingLastName;

            if (objRedeemProfileInfoConfig.zipcode)
                params.zipcode = objRedeemProfileInfoConfig.zipcode;

            if (objRedeemProfileInfoConfig.addressKey)
                params.address_key = objRedeemProfileInfoConfig.addressKey;
        }

        if (objRedeemInfoConfig) {
            if (objRedeemInfoConfig.info1) params.info1 = objRedeemInfoConfig.info1;
            if (objRedeemInfoConfig.info2) params.info2 = objRedeemInfoConfig.info2;
            if (objRedeemInfoConfig.info3) params.info3 = objRedeemInfoConfig.info3;
            if (objRedeemInfoConfig.info4) params.info4 = objRedeemInfoConfig.info4;
            if (objRedeemInfoConfig.info5) params.info5 = objRedeemInfoConfig.info5;
        }

        if (objRedeemLocationConfig) {
            if (objRedeemLocationConfig.locationId) params.location_id = objRedeemLocationConfig.locationId;
            if (objRedeemLocationConfig.center) params.center = objRedeemLocationConfig.center;
            if (objRedeemLocationConfig.latitude) params.latitude = objRedeemLocationConfig.latitude;
            if (objRedeemLocationConfig.longitude) params.longitude = objRedeemLocationConfig.longitude;
        }

        if (objRedeemOtherConfig) {
            if (objRedeemOtherConfig.isCache == false) params.cache = objRedeemOtherConfig.isCache;
            if (objRedeemOtherConfig.redeemBy) params.redeem_by = objRedeemOtherConfig.redeemBy;
            if (objRedeemOtherConfig.tranId) params.tranId = objRedeemOtherConfig.tranId;
            if (objRedeemOtherConfig.reservationjson) params.reservationjson = objRedeemOtherConfig.reservationjson;
            if (objRedeemOtherConfig.promoCode) params.promocode = objRedeemOtherConfig.promoCode;
            if (objRedeemOtherConfig.spBaht) params.sp_baht = objRedeemOtherConfig.spBaht;
            if (objRedeemOtherConfig.spPoints) params.sp_points = objRedeemOtherConfig.spPoints;
            if (objRedeemOtherConfig.giftTo) params.giftto = objRedeemOtherConfig.giftTo;
        }

        var strUrl = Vue.bzbsConfig.bzbsServiceUrl + "/campaign/" + campaignId + "/redeem";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params).then((res) => {
                var data = res.data;

                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiRedeemCampaignBooking: function (strBzbsToken, campaignId, objRedeemConfig, objRedeemProfileInfoConfig, objRedeemInfoConfig, objRedeemLocationConfig, objRedeemOtherConfig, memberId) {
        var params = {};
        if (!campaignId) {
            // failCallback("-9400", "-9400", "Bad parameter::Missing campaign model configuration.", "template_send", objRedeemConfig);
            return null;
        } else {
            params.campaignId = campaignId;
        }

        if (memberId) {
            params.memberId = memberId;
        }

        if (objRedeemInfoConfig) {
            var info3 = JSON.parse(objRedeemInfoConfig.info3);
            params.firstName = info3.firstname;
            params.lastName = info3.lastname;
            params.branch = info3.brance;
            params.eventDate = info3.datetime;
            params.masterCampaingId = info3.masterCampaingId;
            console.log(info3);
        }

        if (!objRedeemConfig) {
            // failCallback("-9400", "-9400", "Bad parameter::Missing redeem configuration.", "template_send", objRedeemConfig);
            return null;
        } else {
            if (objRedeemConfig.redeemMedia) params.redeem_media = objRedeemConfig.redeemMedia;
            if (objRedeemConfig.walletCard) params.walletcard = objRedeemConfig.walletCard;
        }

        if (objRedeemProfileInfoConfig) {
            if (objRedeemProfileInfoConfig.firstName)
                params.firstname = objRedeemProfileInfoConfig.firstName;

            if (objRedeemProfileInfoConfig.lastName)
                params.lastname = objRedeemProfileInfoConfig.lastName;

            if (objRedeemProfileInfoConfig.address)
                params.address = objRedeemProfileInfoConfig.address;

            if (objRedeemProfileInfoConfig.contactNumber)
                params.contact_number = objRedeemProfileInfoConfig.contactNumber;

            if (objRedeemProfileInfoConfig.email)
                params.email = objRedeemProfileInfoConfig.email;

            if (objRedeemProfileInfoConfig.shippingFirstName)
                params.shippingFirstName = objRedeemProfileInfoConfig.shippingFirstName;

            if (objRedeemProfileInfoConfig.shippingLastName)
                params.shippingLastName = objRedeemProfileInfoConfig.shippingLastName;

            if (objRedeemProfileInfoConfig.zipcode)
                params.zipcode = objRedeemProfileInfoConfig.zipcode;

            if (objRedeemProfileInfoConfig.addressKey)
                params.address_key = objRedeemProfileInfoConfig.addressKey;
        }

        if (objRedeemInfoConfig) {
            if (objRedeemInfoConfig.info1) params.info1 = objRedeemInfoConfig.info1;
            if (objRedeemInfoConfig.info2) params.info2 = objRedeemInfoConfig.info2;
            if (objRedeemInfoConfig.info3) params.info3 = objRedeemInfoConfig.info3;
            if (objRedeemInfoConfig.info4) params.info4 = objRedeemInfoConfig.info4;
            if (objRedeemInfoConfig.info5) params.info5 = objRedeemInfoConfig.info5;
        }

        if (objRedeemLocationConfig) {
            if (objRedeemLocationConfig.locationId) params.location_id = objRedeemLocationConfig.locationId;
            if (objRedeemLocationConfig.center) params.center = objRedeemLocationConfig.center;
            if (objRedeemLocationConfig.latitude) params.latitude = objRedeemLocationConfig.latitude;
            if (objRedeemLocationConfig.longitude) params.longitude = objRedeemLocationConfig.longitude;
        }

        if (objRedeemOtherConfig) {
            if (objRedeemOtherConfig.isCache == false) params.cache = objRedeemOtherConfig.isCache;
            if (objRedeemOtherConfig.redeemBy) params.redeem_by = objRedeemOtherConfig.redeemBy;
            if (objRedeemOtherConfig.tranId) params.tranId = objRedeemOtherConfig.tranId;
            if (objRedeemOtherConfig.reservationjson) params.reservationjson = objRedeemOtherConfig.reservationjson;
            if (objRedeemOtherConfig.promoCode) params.promocode = objRedeemOtherConfig.promoCode;
            if (objRedeemOtherConfig.spBaht) params.sp_baht = objRedeemOtherConfig.spBaht;
            if (objRedeemOtherConfig.spPoints) params.sp_points = objRedeemOtherConfig.spPoints;
            if (objRedeemOtherConfig.giftTo) params.giftto = objRedeemOtherConfig.giftTo;
        }

        var strUrl = Vue.bzbsConfig.bzbsModuleUrl + "/main/book";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params).then((res) => {
                var data = res.data;

                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiRedeemGift: function(strBzbsToken, objDataRedeem) {

        var params = {};
        if (objDataRedeem.memberCode) {

            params.memberCode = objDataRedeem.memberCode;
        }
        if (objDataRedeem.redemptionDate) {

            params.redemptionDate = objDataRedeem.redemptionDate;
        }
        if (objDataRedeem.counterName) {

            params.counterName = objDataRedeem.counterName;
        }
        if (objDataRedeem.counterCode) {

            params.counterCode = objDataRedeem.counterCode;
        }
        if (objDataRedeem.name) {

            params.name = objDataRedeem.name;
        }
        if (objDataRedeem.mobileNumber) {

            params.mobileNumber = objDataRedeem.mobileNumber;
        }
        if (objDataRedeem.productCode) {

            params.productCode = objDataRedeem.productCode;
        }
        if (objDataRedeem.productName) {

            params.productName = objDataRedeem.productName;
        }

        var strUrl = Vue.bzbsConfig.bzbsModuleUrl + "/gift/reserve";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params).then((res) => {
                var data = res.data;

                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiGetchanelDior: function() {
        var url = `${this.config().bzbsBlobUrl}/config/dior/config/config.json`;
        return BzbsApi.connectBzbsGetBlob(url);
    },

}
